<template lang="pug">
	.editor-control-input-switch(:class="{'change-process': changedValue !== null, [theme]: true, disabled: disabled}")
		.input-title(v-if="title") {{title}}
		.control-number
			.switch-control
				label.switch.switch-label.switch-pill.switch-success.form-check-label(:class="{'switch-sm': theme === 'dark-mini'}")
					input.switch-input.form-check-input(type="checkbox" :checked="getValue()" v-on:change="changeValue($event.target.checked)" :disabled="disabled")
					span.switch-slider(data-checked="On" data-unchecked="Off")
					span.switch-handle
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import { Elements }						from './../../../services/Elements'

	export default {
		name: 'InputSwitch',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Changed": function() {

					this.update();

				}
			}
		},
		components: {},
		props: ["title", "default", "value", "disabled", "options", "theme"],
		data() {

			this.element = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

		},
		methods: {
			collectData() {

				this.element = Elements.SelectedElement;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			setValue(value, forceUpdate = false) {

				this.changedValue = value;

				if (forceUpdate) this.$forceUpdate();
				else this.update();

				this.sendValue(this.getValue());

			},
			restoreValueType(value) {

				return !!value;

			},
			sendValue(value) {

				this.$emit('input', value);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', value);

					//this.changedValue = null;

					this.update();

				}, 500);

			},
			changeValue(value) {

				this.changedValue = value;

				this.setValue(this.changedValue, false);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-input-switch.dark-mini
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-number
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.switch-control
				margin-top: 5px

				.switch-label.switch-sm
					width: 38px
					height: 20px

					.switch-slider
						background-color: rgba(255, 255, 255, 0.09)
						border-color: rgba(255, 255, 255, 0.05)

					.switch-slider::before
						width: 14px
						height: 14px
						border-radius: 12px
						top: 2px
						left: 2px
						border-color: rgba(255, 255, 255, 0.05)
						background-color: rgba(255, 255, 255, 0.09)

					.switch-slider::after
						top: 49%

				.switch-success .switch-input:checked + .switch-slider::before
					background-color: rgba(255, 255, 255, 0.5)

	.editor-control-input-switch.dark-medium

		.control-number

			.switch-control
				font-size: 0

				.switch-label

					.switch-slider
						border: 1px solid #23282c
						border-radius: 20px
						background: #515b65
						transition: none

						&:hover
							background: #515b65
							border: 1px solid rgba(255, 255, 255, 0.3)

					.switch-slider::before
						width: 16px
						height: 16px
						border-radius: 8px
						top: 4px
						left: 4px
						border-color: rgba(255, 255, 255, 0.05)
						background-color: rgba(255, 255, 255, 0.09)


				.switch-label:has(input[type="checkbox"]:checked)

					.switch-slider::before
						background-color: rgba(255, 255, 255, 0.7)
	
	.editor-control-input-switch.dark-medium.disabled
		opacity: 0.4

		.control-number

			.switch-control

				.switch-label

					.switch-slider

						&:hover
							border: 1px solid #23282c
							cursor: default

	.editor-control-input-switch.colour-medium
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-number
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.switch-control
				margin-top: 5px

				.switch-label
					width: 48px
					height: 24px

					.switch-slider
						//background-color: rgba(255, 255, 255, 0.09)
						//border: 1px solid #23282c
						border-radius: 20px

					.switch-slider::before
						width: 16px
						height: 16px
						border-radius: 8px
						top: 3px
						left: 3px
						//border-color: rgba(255, 255, 255, 0.05)
						//background-color: rgba(255, 255, 255, 0.09)

					.switch-slider::after
						//top: 47%
						right: 2px
						color: #e4e7ea

				.switch-success .switch-input:checked + .switch-slider::before
					//background-color: var(--green)

		.control-number:hover

			.switch-control

				.switch-label.switch-sm

					.switch-slider
						border: 1px solid rgba(255, 255, 255, 0.3)


</style>
